<template>
  <div>
    <cases-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :titleObj="titleObj"
      :logo="logo"
    ></cases-header>
    <cases-center :cases="caseInfo" :type="caseType"></cases-center>
    <cases-footer :bottom="bottom" :bottomInfo="contactInfo"></cases-footer>
  </div>
</template>

<script>
import CasesHeader from "@/components/mobile/Header";
import CasesCenter from "@/components/mobile/CasesCenter";
import CasesFooter from "@/components/mobile/Footer";
export default {
  name: "cases",
  data() {
    return {
      actIndex: 4,
      topStyle: "",
      imgList: [],
      bottom: {},
      logo: "",
      contactInfo: {},
      caseType: [],
      caseInfo: [],
      titleObj:{
        title:'案例中心',
        desc:'多种平台与开发技术上大量案例的积累 \n是我们为您提供优质开发服务的底气'
      }
    };
  },
  components: {
    CasesHeader,
    CasesCenter,
    CasesFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
  },
  methods: {
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle =
              "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.replace("/m_cases");
      } else {
        this.$router.replace("/cases");
      }
    },
    getPageData() {
      this.$http.post("home/index/m_cases", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.topStyle =
          "background:url('" +
          this.$imgUrl +
          res.data.header[0].m_cgal.replace(/\\/g, "/") +
          "')";
        this.contactInfo = res.data.contact[0];
        this.caseType = res.data.type;
        this.caseInfo = res.data.case;
        this.$nextTick(() => {
          // this.$refs.jobRef.imgSwiper()
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/Cases.vue